import { DeconstructedTime, DeconstructedTimeTz } from './deconstruct-date.function';
import { SECONDS_IN_HOUR, SECONDS_IN_MINUTE } from './duration.constants';

export function addMillisecondsToTime<T extends DeconstructedTime | DeconstructedTimeTz>(deconstructed: T, amount: number): T {
  let milliseconds = (deconstructed.milliseconds ?? 0)
    + (deconstructed.seconds ?? 0) * 1000
    + (deconstructed.minutes ?? 0) * 1000 * SECONDS_IN_MINUTE
    + (deconstructed.hours ?? 0) * 1000 * SECONDS_IN_HOUR
    + amount;
  if(milliseconds < 0)
    milliseconds += 1000 * SECONDS_IN_HOUR * 24;
  const returnValue = {...deconstructed};
  returnValue.hours = Math.trunc(milliseconds / (1000 * SECONDS_IN_HOUR));
  const remAfterHours = milliseconds % (1000 * SECONDS_IN_HOUR);
  returnValue.minutes = Math.trunc(remAfterHours / (1000 * SECONDS_IN_MINUTE));
  const remAfterMinutes = remAfterHours % (1000 * SECONDS_IN_MINUTE);
  returnValue.seconds = Math.trunc(remAfterMinutes / 1000);
  returnValue.milliseconds = remAfterMinutes % 1000;
  returnValue.hours = (returnValue.hours % 24 + 24) % 24;

  return returnValue;
}
